// extracted by mini-css-extract-plugin
export default {"nameList":"ProfilePageList_nameList__aS1pt","name":"ProfilePageList_name__xDNht","header":"ProfilePageList_header__sRWvF"};